import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Table, TableLazyLoadEvent } from "primeng/table";
import { FilterMetadata } from "primeng/api/filtermetadata";
import { formatDate } from "@angular/common";
import { MedOptionType } from "@mk/med-ui";
import { PAGINATION_OPTIONS } from "@app/components/supplies/supplies.component";
import { Supply } from "@app/models/supply.model";
import { SupplyApiService } from "@app/services/supply-api.service";
import { GoodApiService } from "@app/services/good-api.service";
import { Good } from "@app/models/good.model";
import { HttpParams } from "@angular/common/http";
import { DataService } from "@app/services/data.service";
import { BasketService } from "@app/components/basket/basket.service";

@Component({
  templateUrl: "./goods.component.html",
  styleUrls: ["./goods.component.scss", "../../distributions/doz/distributions.doz.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class GoodsComponent implements OnInit {

  constructor(private route: ActivatedRoute,
              private router: Router,
              private supplyService: SupplyApiService,
              private goodsService: GoodApiService,
              public dataService: DataService,
              public basketService: BasketService) {}

    @ViewChild("dt") dt: Table | undefined;
    supplyId: string | null = "";
    supply: Supply = {};
    goods: any[] = [];
    selectedPageNumber = 1;
    pageSize = 10;
    tabHeader: { label: string; key: string; date: boolean; filter: boolean; }[] = tabHeader2;
    goodsList:  Good[] = [];
    totalRows = 0;
    filterActive = true;
    filterField: string | string[] | null | undefined = "";
    sortOrder: number | undefined | null = null;
    tableState: TableLazyLoadEvent = {};
    components: any[] = [];
    readonly paginationOptions: MedOptionType<number>[] = PAGINATION_OPTIONS;
    showedOnPage = 10;

    ngOnInit(): void {

      if ("DOZ" === this.dataService.userRoleValue.getValue()) {
        this.router.navigate(["/"]);
      }

      this.supplyId = this.route.snapshot.paramMap.get("supplyId");

      if (this.supplyId === null) {
        return;
      }
      this.supplyId = decodeURIComponent(this.supplyId);

      this.supplyService.getSupply(this.supplyId).subscribe(data => {
        this.supply = data;
        this.loadData(this.tableState);
      });
      this.loadColumnOrder();
    }

    saveColumnOrder() {
      localStorage.setItem("goodsColumnOrder", JSON.stringify(this.tabHeader));
    }

    loadColumnOrder() {
      const savedOrder = localStorage.getItem("goodsColumnOrder");
      if (savedOrder) {
        this.tabHeader = JSON.parse(savedOrder);
      }
    }

    getFirstShowedRowIndex(): number {
      return this.selectedPageNumber === 0 ? 0 : (this.selectedPageNumber - 1) * this.pageSize;
    }

    getGoods(
      page: number | undefined,
      order = "desc",
      field = "mnnId",
      filters: { [s: string]: FilterMetadata | FilterMetadata[] | undefined; } = {},
    ): void {
      let params: HttpParams = new HttpParams();
      this.selectedPageNumber = page ? page : 0;

      params = params.append("conditions[0].fieldName", "supply~supplyId");
      params = params.append("conditions[0].value", this.supplyId ? this.supplyId : "");
      params = params.append("conditions[0].operator", "equals");

      const sortFieldAndOrder = `${field},${order}`;

      this.goodsService.getGoodsAll(this.addFilterParams(filters, params, sortFieldAndOrder)).subscribe(data => {
        this.goodsList = data.content;
        this.totalRows = data.totalElements;

      });
    }

    addFilterParams(filters: { [s: string]: FilterMetadata | FilterMetadata[] | undefined; } = {}, params: HttpParams, sortParams: string): HttpParams {
      if (filters) {
        let counter = 1;
        tabHeader2.forEach((column => {
          if (filters[column.key]) {
            const str: FilterMetadata | FilterMetadata[] | undefined = filters[column.key];
            if (Array.isArray(str) && str[0].value) {
              const [first] = str;
              const { value } = first;
              let fieldName: string = column.key;
              if (column.date) {
                const selectedDate: Date = new Date(value);
                // selectedDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDay())
                // ('yyyy-MM-ddThh:mm:ss')
                params = params.append(`conditions[${counter}].fieldName`, fieldName);
                params = params.append(`conditions[${counter}].value`, formatDate(selectedDate, "yyyy-MM-ddThh:mm:ss", "en-US"));
                params = params.append(`conditions[${counter}].operator`, "GREATER_THAN_EQUALS");
                counter++;
                selectedDate.setDate(selectedDate.getDate() + 1);
                params = params.append(`conditions[${counter}].fieldName`, fieldName);
                params = params.append(`conditions[${counter}].value`, formatDate(selectedDate, "yyyy-MM-ddThh:mm:ss", "en-US"));
                params = params.append(`conditions[${counter}].operator`, "LESS_THAN");
                counter++;
              } else {
                if (column.joinTable) {
                  fieldName = column.joinTable + "_" + fieldName;
                }
                params = params.append(`conditions[${counter}].fieldName`, fieldName);
                params = params.append(`conditions[${counter}].value`, value);
                params = params.append(`conditions[${counter}].operator`, "contains");
                counter++;
              }
            }
          }
        }));
        params = params.append("page", this.selectedPageNumber - 1);
        params = params.append("size", this.pageSize);
        params = params.append("sort", sortParams);
      }
      return params;
    }

    getPathtpStatusImg(rowElement: string): string {
      let color: string;
      switch (rowElement) {
      case "Очікується": color = "yellow"; break;
      case "Затримка": color = "red"; break;
      case "Підготовка": color = "grey"; break;
      default: color = "green";
      }
      return `assets/icons/table/Statys_indicator_${color}.png`;
    }

    goToDetails(id: string): void {
      this.router.navigate(["/supplies/supply/" + encodeURIComponent(this.supplyId + "") + "/availability/" + encodeURIComponent(id)], { relativeTo: this.route });
    }

    loadData($event: TableLazyLoadEvent, resetState = false) {
      this.tableState = $event;
      this.filterField = $event.sortField;
      if (Object.keys(this.supply).length === 0) {
        return;
      }
      if (resetState) {
        if ($event.sortField) {
          this.filterActive = this.sortOrder !== -1;
        } else {
          this.filterActive = false;
        }
      }
      if (this.sortOrder === -1 && resetState) {
        this.sortOrder = null;
        this.dt?.reset();
      } else {
        this.getGoods(this.selectedPageNumber, $event.sortOrder === 1 ? "asc" : "desc", $event.sortField?.toString(), $event.filters);
        this.sortOrder = $event.sortOrder;
      }
    }

    pageChange(pageNumber: number) {
      this.selectedPageNumber = pageNumber;
      this.loadData(this.tableState);
    }

    pageSizeChanged(pageSize: number) {
      this.pageSize = pageSize;
      this.selectedPageNumber = 1;
      this.loadData(this.tableState);
    }

    onChangeHandlerGood(good: any): void {
      this.basketService.addIfNotExistsAndRemoveIfExists(good.specificationIds, good.directionId, good.warehouseName);
    }

    getComponents(good: any) {
      this.components = [];
      if (good.components && good.components.length > 0) {
        this.components = good.components[0];
      }
    }
}

export const tabHeader2 = [
  { key: "1", label: "MHH ID", date: false, filter: true, joinTable: "" },
  { key: "2", label: "LOV ID", date: false, filter: true, joinTable: "" },
  { key: "3", label: "Напрям", date: false, filter: true, joinTable: "" },
  { key: "4", label: "Піднапрям", date: false, filter: true, joinTable: "" },
  { key: "5", label: "МНН", date: false, filter: true, joinTable: "" },
  { key: "6", label: "Дозування", date: false, filter: true, joinTable: "" },
  { key: "7", label: "Торгова назва", date: false, filter: true, joinTable: "" },
  { key: "8", label: "Виробник", date: false, filter: true, joinTable: "" },
  { key: "9", label: "Країна виробника", date: false, filter: true, joinTable: "" },
  { key: "10", label: "Країна походження", date: false, filter: true, joinTable: "" },
  { key: "11", label: "Кратність", date: false, filter: true, joinTable: "" },
  { key: "12", label: "Серія/каталожний номер", date: false, filter: true, joinTable: "" },
  { key: "13", label: "Кількість", date: false, filter: true, joinTable: "" },
  { key: "14", label: "Вартість за одиницю, грн", date: false, filter: true, joinTable: "" },
  { key: "15", label: "Загальна вартість", date: false, filter: true, joinTable: "" },
  { key: "16", label: "Дата виробництва", date: true, filter: true, joinTable: "" },
  { key: "17", label: "Термін придатності", date: false, filter: true, joinTable: "" },
];
